/*
 * iam
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.27
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {APIKeyLabel} from '../model/APIKeyLabel';
import {AddApiKey} from '../model/AddApiKey';
import {AddIncludeSubOrgsOf} from '../model/AddIncludeSubOrgsOf';
import {AddOrganizationMember} from '../model/AddOrganizationMember';
import {Authorization} from '../model/Authorization';
import {CreateGrantBody} from '../model/CreateGrantBody';
import {EmailAddress} from '../model/EmailAddress';
import {EmailAddressValidation} from '../model/EmailAddressValidation';
import {Error} from '../model/Error';
import {GetOrganizationUsersResponseBody} from '../model/GetOrganizationUsersResponseBody';
import {IsMember} from '../model/IsMember';
import {IyoID} from '../model/IyoID';
import {JoinOrganizationInvitation} from '../model/JoinOrganizationInvitation';
import {KeyStoreKey} from '../model/KeyStoreKey';
import {LocalizedInfoText} from '../model/LocalizedInfoText';
import {Member} from '../model/Member';
import {Membership} from '../model/Membership';
import {Notification} from '../model/Notification';
import {Organization} from '../model/Organization';
import {OrganizationAPIKey} from '../model/OrganizationAPIKey';
import {OrganizationLogo} from '../model/OrganizationLogo';
import {OrganizationTreeItem} from '../model/OrganizationTreeItem';
import {PhoneNumberValidation} from '../model/PhoneNumberValidation';
import {Phonenumber} from '../model/Phonenumber';
import {PublicKey} from '../model/PublicKey';
import {RequiredScope} from '../model/RequiredScope';
import {SetOrgMember} from '../model/SetOrgMember';
import {SetOrgOwner} from '../model/SetOrgOwner';
import {TOTPSecret} from '../model/TOTPSecret';
import {TOTPSecretIssuer} from '../model/TOTPSecretIssuer';
import {TwoFAMethods} from '../model/TwoFAMethods';
import {UpdateAPIkey} from '../model/UpdateAPIkey';
import {UpdateGrantBody} from '../model/UpdateGrantBody';
import {UpdateOrganizationOrgMemberShip} from '../model/UpdateOrganizationOrgMemberShip';
import {UpdatePassword} from '../model/UpdatePassword';
import {UpdateUserName} from '../model/UpdateUserName';
import {User} from '../model/User';
import {UserAPIKey} from '../model/UserAPIKey';
import {UserGrants} from '../model/UserGrants';
import {UserOrganizations} from '../model/UserOrganizations';
import {Userview} from '../model/Userview';
import {ValidityTime} from '../model/ValidityTime';
import {VerifyEmailAddress} from '../model/VerifyEmailAddress';
import {VerifyPhoneNumber} from '../model/VerifyPhoneNumber';

/**
* Default service.
* @module api/DefaultApi
* @version 0.1
*/
export class DefaultApi {

    /**
    * Constructs a new DefaultApi. 
    * @alias module:api/DefaultApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the acceptMembership operation.
     * @callback moduleapi/DefaultApi~acceptMembershipCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JoinOrganizationInvitation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Accept membership in organization
     * @param {module:model/JoinOrganizationInvitation} body 
     * @param {String} globalid 
     * @param {String} role 
     * @param {String} username 
     * @param {module:api/DefaultApi~acceptMembershipCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    acceptMembership(body, globalid, role, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling acceptMembership");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling acceptMembership");
      }
      // verify the required parameter 'role' is set
      if (role === undefined || role === null) {
        throw new Error("Missing the required parameter 'role' when calling acceptMembership");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling acceptMembership");
      }

      let pathParams = {
        'globalid': globalid,'role': role,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = JoinOrganizationInvitation;

      return this.apiClient.callApi(
        '/users/{username}/organizations/{globalid}/roles/{role}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the acceptOrganizationInvite operation.
     * @callback moduleapi/DefaultApi~acceptOrganizationInviteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JoinOrganizationInvitation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Accept the invite for one of your organizations
     * @param {module:model/JoinOrganizationInvitation} body 
     * @param {String} globalid 
     * @param {String} invitingorg 
     * @param {String} role 
     * @param {module:api/DefaultApi~acceptOrganizationInviteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    acceptOrganizationInvite(body, globalid, invitingorg, role, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling acceptOrganizationInvite");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling acceptOrganizationInvite");
      }
      // verify the required parameter 'invitingorg' is set
      if (invitingorg === undefined || invitingorg === null) {
        throw new Error("Missing the required parameter 'invitingorg' when calling acceptOrganizationInvite");
      }
      // verify the required parameter 'role' is set
      if (role === undefined || role === null) {
        throw new Error("Missing the required parameter 'role' when calling acceptOrganizationInvite");
      }

      let pathParams = {
        'globalid': globalid,'invitingorg': invitingorg,'role': role
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = JoinOrganizationInvitation;

      return this.apiClient.callApi(
        '/organizations/{globalid}/organizations/{invitingorg}/roles/{role}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the addApiKey operation.
     * @callback moduleapi/DefaultApi~addApiKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserAPIKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Adds an APIKey to the user
     * @param {module:model/AddApiKey} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~addApiKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    addApiKey(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling addApiKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling addApiKey");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserAPIKey;

      return this.apiClient.callApi(
        '/users/{username}/apikeys', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the addIncludeSubOrgsOf operation.
     * @callback moduleapi/DefaultApi~addIncludeSubOrgsOfCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Organization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add an orgmember or orgowner organization to the includesuborgsof list
     * @param {module:model/AddIncludeSubOrgsOf} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~addIncludeSubOrgsOfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    addIncludeSubOrgsOf(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling addIncludeSubOrgsOf");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling addIncludeSubOrgsOf");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Organization;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgmembers/includesuborgs', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the addOrganizationMember operation.
     * @callback moduleapi/DefaultApi~addOrganizationMemberCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JoinOrganizationInvitation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Invite someone to become member of an organization.
     * @param {module:model/AddOrganizationMember} body 
     * @param {String} globalid 
     * @param {Object} opts Optional parameters
     * @param {String} opts.invitenotification Set to &#x60;none&#x60; to suppress sending an sms or email
     * @param {module:api/DefaultApi~addOrganizationMemberCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    addOrganizationMember(body, globalid, opts, callback) {
      opts = opts || {};
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling addOrganizationMember");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling addOrganizationMember");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        'invitenotification': opts['invitenotification']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = JoinOrganizationInvitation;

      return this.apiClient.callApi(
        '/organizations/{globalid}/members', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the addOrganizationOwner operation.
     * @callback moduleapi/DefaultApi~addOrganizationOwnerCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JoinOrganizationInvitation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Invite someone to become owner of an organization.
     * @param {module:model/Member} body 
     * @param {String} globalid 
     * @param {Object} opts Optional parameters
     * @param {String} opts.invitenotification Set to &#x60;none&#x60; to suppress sending an sms or email
     * @param {module:api/DefaultApi~addOrganizationOwnerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    addOrganizationOwner(body, globalid, opts, callback) {
      opts = opts || {};
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling addOrganizationOwner");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling addOrganizationOwner");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        'invitenotification': opts['invitenotification']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = JoinOrganizationInvitation;

      return this.apiClient.callApi(
        '/organizations/{globalid}/owners', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the addPublicKey operation.
     * @callback moduleapi/DefaultApi~addPublicKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublicKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add a public key
     * @param {module:model/PublicKey} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~addPublicKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    addPublicKey(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling addPublicKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling addPublicKey");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PublicKey;

      return this.apiClient.callApi(
        '/users/{username}/publickeys', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the addRequiredScope operation.
     * @callback moduleapi/DefaultApi~addRequiredScopeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Adds a required scope
     * @param {module:model/RequiredScope} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~addRequiredScopeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    addRequiredScope(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling addRequiredScope");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling addRequiredScope");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/requiredscopes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createNewOrganization operation.
     * @callback moduleapi/DefaultApi~createNewOrganizationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Organization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new organization. 1 user should be in the owners list. Validation is performed to check if the securityScheme allows management on this user.
     * @param {module:model/Organization} body 
     * @param {module:api/DefaultApi~createNewOrganizationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createNewOrganization(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createNewOrganization");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Organization;

      return this.apiClient.callApi(
        '/organizations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createNewOrganizationAPIKey operation.
     * @callback moduleapi/DefaultApi~createNewOrganizationAPIKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationAPIKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new API Key, a secret itself should not be provided, it will be generated serverside.
     * @param {module:model/OrganizationAPIKey} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~createNewOrganizationAPIKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createNewOrganizationAPIKey(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createNewOrganizationAPIKey");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling createNewOrganizationAPIKey");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = OrganizationAPIKey;

      return this.apiClient.callApi(
        '/organizations/{globalid}/apikeys', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createNewSubOrganization operation.
     * @callback moduleapi/DefaultApi~createNewSubOrganizationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Organization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new suborganization.
     * @param {module:model/Organization} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~createNewSubOrganizationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createNewSubOrganization(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createNewSubOrganization");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling createNewSubOrganization");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Organization;

      return this.apiClient.callApi(
        '/organizations/{globalid}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createUser operation.
     * @callback moduleapi/DefaultApi~createUserCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new user
     * @param {module:model/User} body 
     * @param {module:api/DefaultApi~createUserCallback} callback The callback function, accepting three arguments: error, data, response
     */
    createUser(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createUser");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createUserGrant operation.
     * @callback moduleapi/DefaultApi~createUserGrantCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserGrants{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new grant for a user
     * @param {module:model/CreateGrantBody} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~createUserGrantCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createUserGrant(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createUserGrant");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling createUserGrant");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserGrants;

      return this.apiClient.callApi(
        '/organizations/{globalid}/grants', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteAPIkey operation.
     * @callback moduleapi/DefaultApi~deleteAPIkeyCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes an API key
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~deleteAPIkeyCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteAPIkey(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling deleteAPIkey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteAPIkey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/apikeys/{label}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteAllUserGrants operation.
     * @callback moduleapi/DefaultApi~deleteAllUserGrantsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete all grants for this user
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteAllUserGrantsCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteAllUserGrants(username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteAllUserGrants");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteAllUserGrants");
      }

      let pathParams = {
        'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/grants/{username}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteAuthorization operation.
     * @callback moduleapi/DefaultApi~deleteAuthorizationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove the authorization for an organization, the granted organization will no longer have access the user&#x27;s information.
     * @param {String} grantedTo 
     * @param {String} username 
     * @param {module:api/DefaultApi~deleteAuthorizationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteAuthorization(grantedTo, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'grantedTo' is set
      if (grantedTo === undefined || grantedTo === null) {
        throw new Error("Missing the required parameter 'grantedTo' when calling deleteAuthorization");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteAuthorization");
      }

      let pathParams = {
        'grantedTo': grantedTo,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/authorizations/{grantedTo}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteDescription operation.
     * @callback moduleapi/DefaultApi~deleteDescriptionCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the description for this organization for a given language key
     * @param {String} langkey 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteDescriptionCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteDescription(langkey, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'langkey' is set
      if (langkey === undefined || langkey === null) {
        throw new Error("Missing the required parameter 'langkey' when calling deleteDescription");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteDescription");
      }

      let pathParams = {
        'langkey': langkey,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/description/{langkey}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteEmailAddress operation.
     * @callback moduleapi/DefaultApi~deleteEmailAddressCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes an email address
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~deleteEmailAddressCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteEmailAddress(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling deleteEmailAddress");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteEmailAddress");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/emailaddresses/{label}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteOrgMember operation.
     * @callback moduleapi/DefaultApi~deleteOrgMemberCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove an organization as a member
     * @param {String} globalid2 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteOrgMemberCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteOrgMember(globalid2, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid2' is set
      if (globalid2 === undefined || globalid2 === null) {
        throw new Error("Missing the required parameter 'globalid2' when calling deleteOrgMember");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteOrgMember");
      }

      let pathParams = {
        'globalid2': globalid2,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgmembers/{globalid2}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteOrgOwner operation.
     * @callback moduleapi/DefaultApi~deleteOrgOwnerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove an organization as an owner
     * @param {String} globalid2 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteOrgOwnerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteOrgOwner(globalid2, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid2' is set
      if (globalid2 === undefined || globalid2 === null) {
        throw new Error("Missing the required parameter 'globalid2' when calling deleteOrgOwner");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteOrgOwner");
      }

      let pathParams = {
        'globalid2': globalid2,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgowners/{globalid2}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteOrganization operation.
     * @callback moduleapi/DefaultApi~deleteOrganizationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes an organization and all data linked to it (join-organization-invitations, oauth_access_tokens, oauth_clients, logo)
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteOrganizationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteOrganization(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteOrganization");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteOrganizationAPIKey operation.
     * @callback moduleapi/DefaultApi~deleteOrganizationAPIKeyCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes an API key
     * @param {String} label 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteOrganizationAPIKeyCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteOrganizationAPIKey(label, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling deleteOrganizationAPIKey");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteOrganizationAPIKey");
      }

      let pathParams = {
        'label': label,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/apikeys/{label}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteOrganizationLogo operation.
     * @callback moduleapi/DefaultApi~deleteOrganizationLogoCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Logo from an organization
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteOrganizationLogoCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteOrganizationLogo(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteOrganizationLogo");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/logo', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deletePublicKey operation.
     * @callback moduleapi/DefaultApi~deletePublicKeyCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a public key
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~deletePublicKeyCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deletePublicKey(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling deletePublicKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deletePublicKey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/publickeys/{label}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteRequiredScope operation.
     * @callback moduleapi/DefaultApi~deleteRequiredScopeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes a required scope
     * @param {String} requiredscope 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteRequiredScopeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteRequiredScope(requiredscope, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'requiredscope' is set
      if (requiredscope === undefined || requiredscope === null) {
        throw new Error("Missing the required parameter 'requiredscope' when calling deleteRequiredScope");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteRequiredScope");
      }

      let pathParams = {
        'requiredscope': requiredscope,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/requiredscopes/{requiredscope}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteUserGrant operation.
     * @callback moduleapi/DefaultApi~deleteUserGrantCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a specified grant for this user
     * @param {String} grant 
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~deleteUserGrantCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteUserGrant(grant, username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'grant' is set
      if (grant === undefined || grant === null) {
        throw new Error("Missing the required parameter 'grant' when calling deleteUserGrant");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteUserGrant");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling deleteUserGrant");
      }

      let pathParams = {
        'grant': grant,'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/grants/{username}/{grant}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteUserPhonenumber operation.
     * @callback moduleapi/DefaultApi~deleteUserPhonenumberCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes a phonenumber
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~deleteUserPhonenumberCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteUserPhonenumber(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling deleteUserPhonenumber");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteUserPhonenumber");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers/{label}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the generateIyoID operation.
     * @callback moduleapi/DefaultApi~generateIyoIDCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IyoID{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Generate a new iyo id for this user
     * @param {String} username 
     * @param {module:api/DefaultApi~generateIyoIDCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    generateIyoID(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling generateIyoID");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = IyoID;

      return this.apiClient.callApi(
        '/users/{username}/identifiers', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the get2faValidityTime operation.
     * @callback moduleapi/DefaultApi~get2faValidityTimeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ValidityTime{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the 2FA validity time for the organization, in seconds
     * @param {String} globalid 
     * @param {module:api/DefaultApi~get2faValidityTimeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    get2faValidityTime(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling get2faValidityTime");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ValidityTime;

      return this.apiClient.callApi(
        '/organizations/{globalid}/2fa/validity', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAPIkey operation.
     * @callback moduleapi/DefaultApi~getAPIkeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserAPIKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get an API key by label
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~getAPIkeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAPIkey(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling getAPIkey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getAPIkey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserAPIKey;

      return this.apiClient.callApi(
        '/users/{username}/apikeys/{label}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAllAuthorizations operation.
     * @callback moduleapi/DefaultApi~getAllAuthorizationsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Authorization>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the list of authorizations.
     * @param {String} username 
     * @param {module:api/DefaultApi~getAllAuthorizationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllAuthorizations(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getAllAuthorizations");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Authorization];

      return this.apiClient.callApi(
        '/users/{username}/authorizations', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAuthorization operation.
     * @callback moduleapi/DefaultApi~getAuthorizationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Authorization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the authorization for a specific organization.
     * @param {String} grantedTo 
     * @param {String} username 
     * @param {module:api/DefaultApi~getAuthorizationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAuthorization(grantedTo, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'grantedTo' is set
      if (grantedTo === undefined || grantedTo === null) {
        throw new Error("Missing the required parameter 'grantedTo' when calling getAuthorization");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getAuthorization");
      }

      let pathParams = {
        'grantedTo': grantedTo,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Authorization;

      return this.apiClient.callApi(
        '/users/{username}/authorizations/{grantedTo}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getDescription operation.
     * @callback moduleapi/DefaultApi~getDescriptionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocalizedInfoText{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the description for an organization for this langkey
     * @param {String} langkey 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getDescriptionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getDescription(langkey, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'langkey' is set
      if (langkey === undefined || langkey === null) {
        throw new Error("Missing the required parameter 'langkey' when calling getDescription");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getDescription");
      }

      let pathParams = {
        'langkey': langkey,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = LocalizedInfoText;

      return this.apiClient.callApi(
        '/organizations/{globalid}/description/{langkey}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getDescriptionWithFallback operation.
     * @callback moduleapi/DefaultApi~getDescriptionWithFallbackCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocalizedInfoText{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the description for an organization for this langkey, try to use the English is there is no description for this langkey
     * @param {String} langkey 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getDescriptionWithFallbackCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getDescriptionWithFallback(langkey, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'langkey' is set
      if (langkey === undefined || langkey === null) {
        throw new Error("Missing the required parameter 'langkey' when calling getDescriptionWithFallback");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getDescriptionWithFallback");
      }

      let pathParams = {
        'langkey': langkey,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = LocalizedInfoText;

      return this.apiClient.callApi(
        '/organizations/{globalid}/description/{langkey}/withfallback', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getEmailAddresses operation.
     * @callback moduleapi/DefaultApi~getEmailAddressesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/EmailAddress>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a list of the user his email addresses.
     * @param {String} username 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.validated optional parameter to filter on only validated email addressses
     * @param {module:api/DefaultApi~getEmailAddressesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getEmailAddresses(username, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getEmailAddresses");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        'validated': opts['validated']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [EmailAddress];

      return this.apiClient.callApi(
        '/users/{username}/emailaddresses', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getInvitations operation.
     * @callback moduleapi/DefaultApi~getInvitationsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/JoinOrganizationInvitation>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the list of pending invitations for users to join this organization.
     * @param {String} globalid 
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.status What status to filter the invitations on. Possible values are pending, accepted and rejected. When not provided, defaults to pending. (default to <.>)
     * @param {module:api/DefaultApi~getInvitationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getInvitations(globalid, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getInvitations");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        'status': opts['status']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [JoinOrganizationInvitation];

      return this.apiClient.callApi(
        '/organizations/{globalid}/invitations', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
     getSubOrgsMembers(globalid, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getSubOrgsMembers");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        'status': opts['status']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];

      return this.apiClient.callApi(
        '/organizations/{globalid}/suborganizations/memberships', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, 'JSON', callback
      );
    }
    getSubOrgsUsers(globalid, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getSubOrgsMembers");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        'status': opts['status']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];

      return this.apiClient.callApi(
        '/organizations/{globalid}/suborganizations/users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, 'JSON', callback
      );
    }
    /**
     * Callback function to receive the result of the getKeyStore operation.
     * @callback moduleapi/DefaultApi~getKeyStoreCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/KeyStoreKey>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Lists all keys written to this users keystore by the accessing organization
     * @param {String} username 
     * @param {module:api/DefaultApi~getKeyStoreCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getKeyStore(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getKeyStore");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [KeyStoreKey];

      return this.apiClient.callApi(
        '/users/{username}/keystore', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getKeyStoreKey operation.
     * @callback moduleapi/DefaultApi~getKeyStoreKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KeyStoreKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the key written to this users keystore for the given label by the accessing organization
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~getKeyStoreKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getKeyStoreKey(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling getKeyStoreKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getKeyStoreKey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = KeyStoreKey;

      return this.apiClient.callApi(
        '/users/{username}/keystore/{label}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getNotifications operation.
     * @callback moduleapi/DefaultApi~getNotificationsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Notification{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the list of notifications, these are pending invitations or approvals or other requests.
     * @param {String} username 
     * @param {module:api/DefaultApi~getNotificationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getNotifications(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getNotifications");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Notification;

      return this.apiClient.callApi(
        '/users/{username}/notifications', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOrganization operation.
     * @callback moduleapi/DefaultApi~getOrganizationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Organization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get organization info
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getOrganizationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOrganization(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getOrganization");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Organization;

      return this.apiClient.callApi(
        '/organizations/{globalid}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOrganizationAPIKey operation.
     * @callback moduleapi/DefaultApi~getOrganizationAPIKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationAPIKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get an api key from an organization
     * @param {String} label 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getOrganizationAPIKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOrganizationAPIKey(label, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling getOrganizationAPIKey");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getOrganizationAPIKey");
      }

      let pathParams = {
        'label': label,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = OrganizationAPIKey;

      return this.apiClient.callApi(
        '/organizations/{globalid}/apikeys/{label}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOrganizationAPIKeyLabels operation.
     * @callback moduleapi/DefaultApi~getOrganizationAPIKeyLabelsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/APIKeyLabel>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the list of active api keys.
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getOrganizationAPIKeyLabelsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOrganizationAPIKeyLabels(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getOrganizationAPIKeyLabels");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [APIKeyLabel];

      return this.apiClient.callApi(
        '/organizations/{globalid}/apikeys', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOrganizationLogo operation.
     * @callback moduleapi/DefaultApi~getOrganizationLogoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationLogo{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the Logo from an organization
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getOrganizationLogoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOrganizationLogo(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getOrganizationLogo");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = OrganizationLogo;

      return this.apiClient.callApi(
        '/organizations/{globalid}/logo', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOrganizationTree operation.
     * @callback moduleapi/DefaultApi~getOrganizationTreeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationTreeItem{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Tree structure of all suborganizations
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getOrganizationTreeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOrganizationTree(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getOrganizationTree");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = OrganizationTreeItem;

      return this.apiClient.callApi(
        '/organizations/{globalid}/tree', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOrganizationUsers operation.
     * @callback moduleapi/DefaultApi~getOrganizationUsersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetOrganizationUsersResponseBody{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all users from this organization, not including suborganizations.
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getOrganizationUsersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOrganizationUsers(globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getOrganizationUsers");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetOrganizationUsersResponseBody;

      return this.apiClient.callApi(
        '/organizations/{globalid}/users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getPublicKey operation.
     * @callback moduleapi/DefaultApi~getPublicKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublicKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a public key
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~getPublicKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPublicKey(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling getPublicKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getPublicKey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PublicKey;

      return this.apiClient.callApi(
        '/users/{username}/publickeys/{label}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getTOTPSecret operation.
     * @callback moduleapi/DefaultApi~getTOTPSecretCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TOTPSecretIssuer{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a TOTP secret and issuer that can be used for setting up two-factor authentication.
     * @param {String} username 
     * @param {module:api/DefaultApi~getTOTPSecretCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTOTPSecret(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getTOTPSecret");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = TOTPSecretIssuer;

      return this.apiClient.callApi(
        '/users/{username}/totp', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getTwoFAMethods operation.
     * @callback moduleapi/DefaultApi~getTwoFAMethodsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TwoFAMethods{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the possible two-factor authentication methods\&quot;
     * @param {String} username 
     * @param {module:api/DefaultApi~getTwoFAMethodsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTwoFAMethods(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getTwoFAMethods");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = TwoFAMethods;

      return this.apiClient.callApi(
        '/users/{username}/twofamethods', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUser operation.
     * @callback moduleapi/DefaultApi~getUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/User{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} username 
     * @param {module:api/DefaultApi~getUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUser(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUser");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = User;

      return this.apiClient.callApi(
        '/users/{username}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUserGrants operation.
     * @callback moduleapi/DefaultApi~getUserGrantsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserGrants{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all grants for a user
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~getUserGrantsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUserGrants(username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUserGrants");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling getUserGrants");
      }

      let pathParams = {
        'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserGrants;

      return this.apiClient.callApi(
        '/organizations/{globalid}/grants/{username}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUserInformation operation.
     * @callback moduleapi/DefaultApi~getUserInformationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Userview{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all of the user his information. This will be limited to the scopes that the user has authorized. See https://gig.gitbooks.io/iam/content/oauth2/scopes.html and https://gig.gitbooks.io/iam/content/oauth2/availableScopes.html for more information.
     * @param {String} username 
     * @param {module:api/DefaultApi~getUserInformationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUserInformation(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUserInformation");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Userview;

      return this.apiClient.callApi(
        '/users/{username}/info', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    getUserInformationYaml(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUserInformationYaml");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];

      return this.apiClient.callApi(
        '/users/{username}/info', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, 'Json', callback
      );
    }
    deleteCurrentUser(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteCurrentUser");
      }

      let pathParams = {

      };
      let queryParams = {

      };
      let headerParams = {
        
      };
      let formParams = {
        'username': username
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];

      return this.apiClient.callApi(
        '/me', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, null, callback
      );
    }
    /**
     * Callback function to receive the result of the getUserOrganizations operation.
     * @callback moduleapi/DefaultApi~getUserOrganizationsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserOrganizations{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the list organizations a user is owner or member of
     * @param {String} username 
     * @param {module:api/DefaultApi~getUserOrganizationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUserOrganizations(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUserOrganizations");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserOrganizations;

      return this.apiClient.callApi(
        '/users/{username}/organizations', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUserPhoneNumbers operation.
     * @callback moduleapi/DefaultApi~getUserPhoneNumbersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Phonenumber>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List of all of the user his phone numbers.
     * @param {String} username 
     * @param {String} validated optional queryParameter to filter on only validated phonenumbers
     * @param {module:api/DefaultApi~getUserPhoneNumbersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUserPhoneNumbers(username, validated, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUserPhoneNumbers");
      }
      // verify the required parameter 'validated' is set
      if (validated === undefined || validated === null) {
        throw new Error("Missing the required parameter 'validated' when calling getUserPhoneNumbers");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        'validated': validated
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Phonenumber];

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUserPhonenumberByLabel operation.
     * @callback moduleapi/DefaultApi~getUserPhonenumberByLabelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Phonenumber{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the details of a phone number.
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~getUserPhonenumberByLabelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUserPhonenumberByLabel(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling getUserPhonenumberByLabel");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getUserPhonenumberByLabel");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Phonenumber;

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers/{label}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the leaveOrganization operation.
     * @callback moduleapi/DefaultApi~leaveOrganizationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the user from an organization
     * @param {String} globalid 
     * @param {String} username 
     * @param {module:api/DefaultApi~leaveOrganizationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    leaveOrganization(globalid, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling leaveOrganization");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling leaveOrganization");
      }

      let pathParams = {
        'globalid': globalid,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/organizations/{globalid}/leave', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the listAPIKeys operation.
     * @callback moduleapi/DefaultApi~listAPIKeysCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserAPIKey>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Lists the API keys
     * @param {String} username 
     * @param {module:api/DefaultApi~listAPIKeysCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    listAPIKeys(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling listAPIKeys");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [UserAPIKey];

      return this.apiClient.callApi(
        '/users/{username}/apikeys', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the listIyoIds operation.
     * @callback moduleapi/DefaultApi~listIyoIdsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IyoID{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all generated iyo ids generated for a user by a party
     * @param {String} username 
     * @param {module:api/DefaultApi~listIyoIdsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    listIyoIds(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling listIyoIds");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = IyoID;

      return this.apiClient.callApi(
        '/users/{username}/identifiers', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the listPublicKeys operation.
     * @callback moduleapi/DefaultApi~listPublicKeysCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PublicKey>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Lists all public keys
     * @param {String} username 
     * @param {module:api/DefaultApi~listPublicKeysCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    listPublicKeys(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling listPublicKeys");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [PublicKey];

      return this.apiClient.callApi(
        '/users/{username}/publickeys', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the listUsersWithGrant operation.
     * @callback moduleapi/DefaultApi~listUsersWithGrantCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a specified grant for this user
     * @param {String} grant 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~listUsersWithGrantCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    listUsersWithGrant(grant, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'grant' is set
      if (grant === undefined || grant === null) {
        throw new Error("Missing the required parameter 'grant' when calling listUsersWithGrant");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling listUsersWithGrant");
      }

      let pathParams = {
        'grant': grant,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ['String'];

      return this.apiClient.callApi(
        '/organizations/{globalid}/grants/havegrant/{grant}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the lookupIyoID operation.
     * @callback moduleapi/DefaultApi~lookupIyoIDCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IyoID{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Lookup the username for an iyo id
     * @param {String} identifier 
     * @param {module:api/DefaultApi~lookupIyoIDCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    lookupIyoID(identifier, callback) {
      
      let postBody = null;
      // verify the required parameter 'identifier' is set
      if (identifier === undefined || identifier === null) {
        throw new Error("Missing the required parameter 'identifier' when calling lookupIyoID");
      }

      let pathParams = {
        'identifier': identifier
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = IyoID;

      return this.apiClient.callApi(
        '/users/identifiers/{identifier}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the registerNewEmailAddress operation.
     * @callback moduleapi/DefaultApi~registerNewEmailAddressCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EmailAddressValidation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Register a new email address
     * @param {module:model/EmailAddress} body 
     * @param {String} username 
     * @param {String} lang language that the validation email should be in.
     * @param {module:api/DefaultApi~registerNewEmailAddressCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    registerNewEmailAddress(body, username, lang, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling registerNewEmailAddress");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling registerNewEmailAddress");
      }
      // verify the required parameter 'lang' is set
      if (lang === undefined || lang === null) {
        throw new Error("Missing the required parameter 'lang' when calling registerNewEmailAddress");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        'lang': lang
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = EmailAddressValidation;

      return this.apiClient.callApi(
        '/users/{username}/emailaddresses', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the registerNewUserPhonenumber operation.
     * @callback moduleapi/DefaultApi~registerNewUserPhonenumberCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PhoneNumberValidation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Register a new phonenumber
     * @param {module:model/Phonenumber} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~registerNewUserPhonenumberCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    registerNewUserPhonenumber(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling registerNewUserPhonenumber");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling registerNewUserPhonenumber");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PhoneNumberValidation;

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the rejectMembership operation.
     * @callback moduleapi/DefaultApi~rejectMembershipCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reject membership invitation in an organization.
     * @param {String} globalid 
     * @param {String} role 
     * @param {String} username 
     * @param {module:api/DefaultApi~rejectMembershipCallback} callback The callback function, accepting three arguments: error, data, response
     */
    rejectMembership(globalid, role, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling rejectMembership");
      }
      // verify the required parameter 'role' is set
      if (role === undefined || role === null) {
        throw new Error("Missing the required parameter 'role' when calling rejectMembership");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling rejectMembership");
      }

      let pathParams = {
        'globalid': globalid,'role': role,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/organizations/{globalid}/roles/{role}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the rejectOrganizationInvite operation.
     * @callback moduleapi/DefaultApi~rejectOrganizationInviteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reject the invite for one of your organizations
     * @param {String} globalid 
     * @param {String} invitingorg 
     * @param {String} role 
     * @param {module:api/DefaultApi~rejectOrganizationInviteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    rejectOrganizationInvite(globalid, invitingorg, role, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling rejectOrganizationInvite");
      }
      // verify the required parameter 'invitingorg' is set
      if (invitingorg === undefined || invitingorg === null) {
        throw new Error("Missing the required parameter 'invitingorg' when calling rejectOrganizationInvite");
      }
      // verify the required parameter 'role' is set
      if (role === undefined || role === null) {
        throw new Error("Missing the required parameter 'role' when calling rejectOrganizationInvite");
      }

      let pathParams = {
        'globalid': globalid,'invitingorg': invitingorg,'role': role
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/organizations/{invitingorg}/roles/{role}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the removeIncludeSubOrgsOf operation.
     * @callback moduleapi/DefaultApi~removeIncludeSubOrgsOfCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove an orgmember or orgowner organization to the includesuborgsof list
     * @param {String} orgmember 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~removeIncludeSubOrgsOfCallback} callback The callback function, accepting three arguments: error, data, response
     */
    removeIncludeSubOrgsOf(orgmember, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'orgmember' is set
      if (orgmember === undefined || orgmember === null) {
        throw new Error("Missing the required parameter 'orgmember' when calling removeIncludeSubOrgsOf");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling removeIncludeSubOrgsOf");
      }

      let pathParams = {
        'orgmember': orgmember,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgmembers/includesuborgs/{orgmember}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the removeOrganizationMember operation.
     * @callback moduleapi/DefaultApi~removeOrganizationMemberCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove a member from an organization.
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~removeOrganizationMemberCallback} callback The callback function, accepting three arguments: error, data, response
     */
    removeOrganizationMember(username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling removeOrganizationMember");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling removeOrganizationMember");
      }

      let pathParams = {
        'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/members/{username}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the removeOrganizationOwner operation.
     * @callback moduleapi/DefaultApi~removeOrganizationOwnerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove an owner from organization
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~removeOrganizationOwnerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    removeOrganizationOwner(username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling removeOrganizationOwner");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling removeOrganizationOwner");
      }

      let pathParams = {
        'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/owners/{username}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the removePendingOrg2OrgInvitation operation.
     * @callback moduleapi/DefaultApi~removePendingOrg2OrgInvitationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Cancel a pending organization invitation.
     * @param {String} globalid 
     * @param {String} globalid2 
     * @param {module:api/DefaultApi~removePendingOrg2OrgInvitationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    removePendingOrg2OrgInvitation(globalid, globalid2, callback) {
      
      let postBody = null;
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling removePendingOrg2OrgInvitation");
      }
      // verify the required parameter 'globalid2' is set
      if (globalid2 === undefined || globalid2 === null) {
        throw new Error("Missing the required parameter 'globalid2' when calling removePendingOrg2OrgInvitation");
      }

      let pathParams = {
        'globalid': globalid,'globalid2': globalid2
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/invitations/organization/{globalid2}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the removePendingOrganizationInvitation operation.
     * @callback moduleapi/DefaultApi~removePendingOrganizationInvitationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Cancel a pending user invitation.
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~removePendingOrganizationInvitationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    removePendingOrganizationInvitation(username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling removePendingOrganizationInvitation");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling removePendingOrganizationInvitation");
      }

      let pathParams = {
        'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/invitations/user/{username}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the removeTOTP operation.
     * @callback moduleapi/DefaultApi~removeTOTPCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Disable TOTP two-factor authentication.
     * @param {String} username 
     * @param {module:api/DefaultApi~removeTOTPCallback} callback The callback function, accepting three arguments: error, data, response
     */
    removeTOTP(username, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling removeTOTP");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/totp', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the saveKeyStoreKey operation.
     * @callback moduleapi/DefaultApi~saveKeyStoreKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KeyStoreKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Saves a new key to this users keystore. The username, globalid and timestamp will be overwritten
     * @param {module:model/KeyStoreKey} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~saveKeyStoreKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    saveKeyStoreKey(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling saveKeyStoreKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling saveKeyStoreKey");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = KeyStoreKey;

      return this.apiClient.callApi(
        '/users/{username}/keystore', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the set2faValidityTime operation.
     * @callback moduleapi/DefaultApi~set2faValidityTimeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the 2FA validity time for the organization
     * @param {Number} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~set2faValidityTimeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    set2faValidityTime(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling set2faValidityTime");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling set2faValidityTime");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/2fa/validity', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setDescription operation.
     * @callback moduleapi/DefaultApi~setDescriptionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocalizedInfoText{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set the description for this organization for a given language key
     * @param {module:model/LocalizedInfoText} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~setDescriptionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    setDescription(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setDescription");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling setDescription");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = LocalizedInfoText;

      return this.apiClient.callApi(
        '/organizations/{globalid}/description', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setOrgMember operation.
     * @callback moduleapi/DefaultApi~setOrgMemberCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add another organization as a member of this one
     * @param {module:model/SetOrgMember} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~setOrgMemberCallback} callback The callback function, accepting three arguments: error, data, response
     */
    setOrgMember(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setOrgMember");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling setOrgMember");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgmembers', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setOrgOwner operation.
     * @callback moduleapi/DefaultApi~setOrgOwnerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add another organization as an owner of this one
     * @param {module:model/SetOrgOwner} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~setOrgOwnerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    setOrgOwner(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setOrgOwner");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling setOrgOwner");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgowners', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setOrganizationLogo operation.
     * @callback moduleapi/DefaultApi~setOrganizationLogoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationLogo{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set the organization Logo for the organization
     * @param {module:model/OrganizationLogo} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~setOrganizationLogoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    setOrganizationLogo(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setOrganizationLogo");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling setOrganizationLogo");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = OrganizationLogo;

      return this.apiClient.callApi(
        '/organizations/{globalid}/logo', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setupTOTP operation.
     * @callback moduleapi/DefaultApi~setupTOTPCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Enable two-factor authentication using TOTP.
     * @param {module:model/TOTPSecret} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~setupTOTPCallback} callback The callback function, accepting three arguments: error, data, response
     */
    setupTOTP(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setupTOTP");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling setupTOTP");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/totp', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateAPIkey operation.
     * @callback moduleapi/DefaultApi~updateAPIkeyCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the label for the API key
     * @param {module:model/UpdateAPIkey} body 
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~updateAPIkeyCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateAPIkey(body, label, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateAPIkey");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling updateAPIkey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updateAPIkey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/apikeys/{label}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateAuthorization operation.
     * @callback moduleapi/DefaultApi~updateAuthorizationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Modify which information an organization is able to see.
     * @param {module:model/Authorization} body 
     * @param {String} grantedTo 
     * @param {String} username 
     * @param {module:api/DefaultApi~updateAuthorizationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateAuthorization(body, grantedTo, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateAuthorization");
      }
      // verify the required parameter 'grantedTo' is set
      if (grantedTo === undefined || grantedTo === null) {
        throw new Error("Missing the required parameter 'grantedTo' when calling updateAuthorization");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updateAuthorization");
      }

      let pathParams = {
        'grantedTo': grantedTo,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/authorizations/{grantedTo}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateDescription operation.
     * @callback moduleapi/DefaultApi~updateDescriptionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocalizedInfoText{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the description for this organization for a given language key
     * @param {module:model/LocalizedInfoText} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~updateDescriptionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateDescription(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateDescription");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling updateDescription");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = LocalizedInfoText;

      return this.apiClient.callApi(
        '/organizations/{globalid}/description', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateEmailAddress operation.
     * @callback moduleapi/DefaultApi~updateEmailAddressCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the label and/or value of an email address
     * @param {module:model/EmailAddress} body 
     * @param {String} label 
     * @param {String} username 
     * @param {String} lang language that the validation email should be in.
     * @param {module:api/DefaultApi~updateEmailAddressCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateEmailAddress(body, label, username, lang, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateEmailAddress");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling updateEmailAddress");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updateEmailAddress");
      }
      // verify the required parameter 'lang' is set
      if (lang === undefined || lang === null) {
        throw new Error("Missing the required parameter 'lang' when calling updateEmailAddress");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        'lang': lang
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/emailaddresses/{label}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateOrganizationAPIKey operation.
     * @callback moduleapi/DefaultApi~updateOrganizationAPIKeyCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the label or other properties of a key.
     * @param {module:model/OrganizationAPIKey} body 
     * @param {String} label 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~updateOrganizationAPIKeyCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateOrganizationAPIKey(body, label, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateOrganizationAPIKey");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling updateOrganizationAPIKey");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling updateOrganizationAPIKey");
      }

      let pathParams = {
        'label': label,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/apikeys/{label}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateOrganizationMemberShip operation.
     * @callback moduleapi/DefaultApi~updateOrganizationMemberShipCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Organization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an organization membership
     * @param {module:model/Membership} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~updateOrganizationMemberShipCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateOrganizationMemberShip(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateOrganizationMemberShip");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling updateOrganizationMemberShip");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Organization;

      return this.apiClient.callApi(
        '/organizations/{globalid}/members', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateOrganizationOrgMemberShip operation.
     * @callback moduleapi/DefaultApi~updateOrganizationOrgMemberShipCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Organization{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the membership status of an organization
     * @param {module:model/UpdateOrganizationOrgMemberShip} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~updateOrganizationOrgMemberShipCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateOrganizationOrgMemberShip(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateOrganizationOrgMemberShip");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling updateOrganizationOrgMemberShip");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Organization;

      return this.apiClient.callApi(
        '/organizations/{globalid}/orgmembers', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updatePassword operation.
     * @callback moduleapi/DefaultApi~updatePasswordCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the user his password
     * @param {module:model/UpdatePassword} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~updatePasswordCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updatePassword(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updatePassword");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updatePassword");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/password', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updatePublicKey operation.
     * @callback moduleapi/DefaultApi~updatePublicKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublicKey{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upates the label and/or key of an existing public key
     * @param {module:model/PublicKey} body 
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~updatePublicKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updatePublicKey(body, label, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updatePublicKey");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling updatePublicKey");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updatePublicKey");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PublicKey;

      return this.apiClient.callApi(
        '/users/{username}/publickeys/{label}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateRequiredScope operation.
     * @callback moduleapi/DefaultApi~updateRequiredScopeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates a required scope
     * @param {String} requiredscope 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~updateRequiredScopeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateRequiredScope(requiredscope, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'requiredscope' is set
      if (requiredscope === undefined || requiredscope === null) {
        throw new Error("Missing the required parameter 'requiredscope' when calling updateRequiredScope");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling updateRequiredScope");
      }

      let pathParams = {
        'requiredscope': requiredscope,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/organizations/{globalid}/requiredscopes/{requiredscope}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateUserGrant operation.
     * @callback moduleapi/DefaultApi~updateUserGrantCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserGrants{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing grant for a user
     * @param {module:model/UpdateGrantBody} body 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~updateUserGrantCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateUserGrant(body, globalid, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateUserGrant");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling updateUserGrant");
      }

      let pathParams = {
        'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserGrants;

      return this.apiClient.callApi(
        '/organizations/{globalid}/grants', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateUserName operation.
     * @callback moduleapi/DefaultApi~updateUserNameCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the user his firstname and lastname
     * @param {module:model/UpdateUserName} body 
     * @param {String} username 
     * @param {module:api/DefaultApi~updateUserNameCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateUserName(body, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateUserName");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updateUserName");
      }

      let pathParams = {
        'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/name', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateUserPhonenumber operation.
     * @callback moduleapi/DefaultApi~updateUserPhonenumberCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the label and/or value of an existing phonenumber.
     * @param {module:model/Phonenumber} body 
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~updateUserPhonenumberCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateUserPhonenumber(body, label, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateUserPhonenumber");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling updateUserPhonenumber");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling updateUserPhonenumber");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers/{label}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the userIsMember operation.
     * @callback moduleapi/DefaultApi~userIsMemberCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IsMember{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Checks if the user has memberschip rights on the organization
     * @param {String} username 
     * @param {String} globalid 
     * @param {module:api/DefaultApi~userIsMemberCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    userIsMember(username, globalid, callback) {
      
      let postBody = null;
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling userIsMember");
      }
      // verify the required parameter 'globalid' is set
      if (globalid === undefined || globalid === null) {
        throw new Error("Missing the required parameter 'globalid' when calling userIsMember");
      }

      let pathParams = {
        'username': username,'globalid': globalid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = IsMember;

      return this.apiClient.callApi(
        '/organizations/{globalid}/users/ismember/{username}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the validateEmailAddress operation.
     * @callback moduleapi/DefaultApi~validateEmailAddressCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EmailAddressValidation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Sends validation email to email address
     * @param {String} label 
     * @param {String} username 
     * @param {String} lang language that the validation email should be in.
     * @param {module:api/DefaultApi~validateEmailAddressCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    validateEmailAddress(label, username, lang, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling validateEmailAddress");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling validateEmailAddress");
      }
      // verify the required parameter 'lang' is set
      if (lang === undefined || lang === null) {
        throw new Error("Missing the required parameter 'lang' when calling validateEmailAddress");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        'lang': lang
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = EmailAddressValidation;

      return this.apiClient.callApi(
        '/users/{username}/emailaddresses/{label}/validate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the validatePhonenumber operation.
     * @callback moduleapi/DefaultApi~validatePhonenumberCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PhoneNumberValidation{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Sends a validation text message to the phone number.
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~validatePhonenumberCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    validatePhonenumber(label, username, callback) {
      
      let postBody = null;
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling validatePhonenumber");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling validatePhonenumber");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PhoneNumberValidation;

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers/{label}/validate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the verifyEmailAddress operation.
     * @callback moduleapi/DefaultApi~verifyEmailAddressCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Verifies an email address
     * @param {module:model/VerifyEmailAddress} body 
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~verifyEmailAddressCallback} callback The callback function, accepting three arguments: error, data, response
     */
    verifyEmailAddress(body, label, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling verifyEmailAddress");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling verifyEmailAddress");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling verifyEmailAddress");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/emailaddresses/{label}/validate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the verifyPhoneNumber operation.
     * @callback moduleapi/DefaultApi~verifyPhoneNumberCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Verifies a phone number
     * @param {module:model/VerifyPhoneNumber} body 
     * @param {String} label 
     * @param {String} username 
     * @param {module:api/DefaultApi~verifyPhoneNumberCallback} callback The callback function, accepting three arguments: error, data, response
     */
    verifyPhoneNumber(body, label, username, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling verifyPhoneNumber");
      }
      // verify the required parameter 'label' is set
      if (label === undefined || label === null) {
        throw new Error("Missing the required parameter 'label' when calling verifyPhoneNumber");
      }
      // verify the required parameter 'username' is set
      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling verifyPhoneNumber");
      }

      let pathParams = {
        'label': label,'username': username
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['oauth20'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;

      return this.apiClient.callApi(
        '/users/{username}/phonenumbers/{label}/validate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}